const question = state => state.question;
const questions = state => state.questions;
const question_group = state => state.question_group;
const validate_question = state => state.validate_question;
const correctGroupChoosed = state => state.correctGroupChoosed;

export default {
  question,
  questions,
  question_group,
  validate_question,
  correctGroupChoosed
};